import React from "react";
import styled from "styled-components";
import { Link } from "react-scroll";
import HeaderImage from "../../assets/img/use3.jpeg";
import FullButton from "../Buttons/FullButton";

export default function Header() {
  return (
    <Wrapper id="home">
      <Glow aria-hidden="true" />
      <HeroGrid className="container">
        <Copy>
          <p className="section-kicker">Welcome to Omnicom Solutions</p>
          <h1>Engineering connections that <em>move Africa forward.</em></h1>
          <Intro>
            Omnicom Solutions Limited is a seasoned multi-vendor Telecommunications,
            Information Technology (IT) Solution design, Services support and software solution provider.
          </Intro>
          <Actions>
            <Link to="services" smooth offset={-70}><FullButton title="Explore our services" /></Link>
            <Link to="contact" smooth offset={-70}><FullButton title="Talk to our team" border /></Link>
          </Actions>
          <CapabilityLine><span>2G</span><i /><span>3G</span><i /><span>4G / LTE</span><i /><span>5G</span><i /><span>Fibre</span></CapabilityLine>
        </Copy>
        <Visual>
          <ImageFrame><img src={HeaderImage} alt="Omnicom field engineer working on telecom infrastructure" /></ImageFrame>
          <NetworkBadge><strong>25,000+</strong><span>network sites commissioned<br />and counting</span></NetworkBadge>
          <MissionCard>
            <span>Our mission</span>
            <p>We are motivated by our mission to provide quality products and services at competitive pricing to the satisfaction of our clients.</p>
          </MissionCard>
          <Orbit aria-hidden="true" />
        </Visual>
      </HeroGrid>
    </Wrapper>
  );
}

const Wrapper = styled.header`
  position: relative; min-height: 850px; padding: 150px 0 90px; overflow: hidden;
  background: linear-gradient(135deg, #fff 0%, #f8faf8 54%, #eff6f1 100%);
  @media (max-width: 900px) { padding: 125px 0 70px; }
`;
const Glow = styled.div`position: absolute; width: 520px; height: 520px; right: -220px; top: -180px; border-radius: 50%; background: rgba(168,207,69,.16); filter: blur(8px);`;
const HeroGrid = styled.div`position: relative; display: grid; grid-template-columns: 1.02fr .98fr; align-items: center; gap: 80px; @media (max-width: 900px) { grid-template-columns: 1fr; gap: 64px; }`;
const Copy = styled.div`
  h1 { max-width: 690px; color: #17152f; font-size: clamp(3.5rem, 6.4vw, 6.3rem); line-height: .94; letter-spacing: -.072em; }
  h1 em { color: #0a9250; font-style: normal; }
  @media (max-width: 520px) { h1 { font-size: clamp(3rem, 15vw, 4.2rem); } }
`;
const Intro = styled.p`max-width: 640px; margin-top: 28px; color: #5d6270; font-size: 1.04rem; line-height: 1.8;`;
const Actions = styled.div`display: flex; gap: 12px; margin-top: 34px; a { width: 205px; } @media (max-width: 480px) { flex-direction: column; a { width: 100%; } }`;
const CapabilityLine = styled.div`
  display: flex; align-items: center; flex-wrap: wrap; gap: 11px; margin-top: 34px; color: #464276; font-size: .72rem; font-weight: 800; letter-spacing: .07em; text-transform: uppercase;
  i { width: 4px; height: 4px; border-radius: 50%; background: #a8cf45; }
`;
const Visual = styled.div`position: relative; min-height: 590px; @media (max-width: 620px) { min-height: 515px; }`;
const ImageFrame = styled.div`
  position: absolute; inset: 0 0 0 56px; overflow: hidden; border-radius: 180px 24px 24px 24px; box-shadow: 0 32px 70px rgba(23,21,47,.2);
  img { width: 100%; height: 100%; object-fit: cover; }
  &::after { content: ""; position: absolute; inset: 0; background: linear-gradient(180deg, transparent 55%, rgba(23,21,47,.28)); }
  @media (max-width: 620px) { inset: 0 0 0 22px; border-radius: 110px 20px 20px 20px; }
`;
const NetworkBadge = styled.div`
  position: absolute; top: 44px; left: 0; z-index: 2; width: 170px; padding: 20px; border-radius: 20px; background: #17152f; color: white; box-shadow: 0 20px 45px rgba(23,21,47,.25);
  strong { display: block; color: #a8cf45; font-size: 1.75rem; line-height: 1; }
  span { display: block; margin-top: 8px; color: rgba(255,255,255,.72); font-size: .67rem; line-height: 1.5; }
  @media (max-width: 620px) { top: 25px; width: 145px; }
`;
const MissionCard = styled.div`
  position: absolute; right: -30px; bottom: 28px; z-index: 2; width: min(340px, 76%); padding: 24px 26px; border-radius: 20px; background: rgba(255,255,255,.94); box-shadow: 0 22px 50px rgba(23,21,47,.18); backdrop-filter: blur(12px);
  span { color: #0a9250; font-size: .67rem; font-weight: 800; letter-spacing: .13em; text-transform: uppercase; }
  p { margin-top: 8px; color: #252737; font-size: .82rem; line-height: 1.65; font-weight: 600; }
  @media (max-width: 1260px) { right: 0; }
`;
const Orbit = styled.div`position: absolute; width: 130px; height: 130px; right: -35px; top: -34px; border: 1px solid rgba(10,146,80,.35); border-radius: 50%; &::before { content: ""; position: absolute; width: 12px; height: 12px; left: 11px; top: 16px; border-radius: 50%; background: #a8cf45; }`;
